import { jsxs, jsx } from 'react/jsx-runtime';
import { isMatch } from 'date-fns';
import { FormatWithLinearLocale } from '../../utils/format.mjs';
import { getStartOfYearDateFromYear } from '../../utils/getStartOfYearDateFromYear.mjs';
import CalendarHeader from '../base/CalendarHeader.mjs';
import { yearHeader } from './yearCalendar.vanilla.mjs';

const START_YEAR_LABEL_FORMAT = {
  en: "yyyy",
  ko: "yyyy"
};
const END_YEAR_LABEL_FORMAT = {
  en: "yyyy",
  ko: "yyyy\uB144"
};
function Header({ startYear, onClickPrevYear, onClickNextYear }) {
  const prevYearOfStartYear = startYear - 1;
  const isPrevButtonDisabled = !isMatch(prevYearOfStartYear.toString(), "yyyy");
  return /* @__PURE__ */ jsxs(CalendarHeader, { children: [
    /* @__PURE__ */ jsxs(CalendarHeader.DateText, { className: yearHeader, children: [
      /* @__PURE__ */ jsx(
        FormatWithLinearLocale,
        {
          date: getStartOfYearDateFromYear(startYear),
          formatMap: START_YEAR_LABEL_FORMAT
        }
      ),
      "\u2013",
      /* @__PURE__ */ jsx(
        FormatWithLinearLocale,
        {
          date: getStartOfYearDateFromYear(startYear + 11),
          formatMap: END_YEAR_LABEL_FORMAT
        }
      )
    ] }),
    /* @__PURE__ */ jsxs(CalendarHeader.RightSlot, { children: [
      /* @__PURE__ */ jsx(
        CalendarHeader.PrevIconButton,
        {
          onClick: onClickPrevYear,
          disabled: isPrevButtonDisabled
        }
      ),
      /* @__PURE__ */ jsx(CalendarHeader.NextIconButton, { onClick: onClickNextYear })
    ] })
  ] });
}

export { Header as default };
//# sourceMappingURL=Header.mjs.map
